import styled from 'styled-components';

const Bredcrumb = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export default Bredcrumb;
